import { Model } from '@vuex-orm/core';

export default class Projectable extends Model {
  static entity = 'projectables';

  static fields() {
    return {
      id: this.uid(),
      project_id: this.attr(null),
      projectable_id: this.attr(null),
      projectable_type: this.attr(null),
    };
  }
}
